module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wj_wrap"
  }, [_c('div', {
    staticClass: "order_main2 order_face",
    style: ({
      width: _vm.width + 'px',
      height: _vm.height + 'px'
    }),
    attrs: {
      "id": "printContent"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "print",
      rawName: "v-print",
      value: (_vm.printObj),
      expression: "printObj"
    }],
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("打 印")]), _vm._v(" "), _c('el-button', [_vm._v("关 闭")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order_header"
  }, [_c('img', {
    staticClass: "code_img",
    attrs: {
      "src": "https://cn2ca-1259002481.cos.na-toronto.myqcloud.com/img/c076e719965343bcb1e09d8adcd8d9f4.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order_box"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("分拨中心：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("蒙特利尔")]), _vm._v(" "), _c('span', {
    staticClass: "l_label l_label2"
  }, [_vm._v("派送点：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("Toronto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticClass: "order_count"
  }, [_vm._v("订单数量：2")]), _vm._v(" "), _c('div', {
    staticClass: "product_list",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('div', {
    staticClass: "l_item",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('span', {
    staticClass: "l_item_val l_name",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("测试测试测试测试测试测试测试测试测试")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("A00010")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("sf0425001")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('span', {
    staticClass: "l_item_val l_name",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("测试商品042211")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("A00011")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("sf0425001")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('span', {
    staticClass: "l_item_val l_name",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("测试商品042211")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("A00011")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("sf0425001")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('span', {
    staticClass: "l_item_val l_name",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("测试商品042211")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("A00011")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("sf0425001")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('span', {
    staticClass: "l_item_val l_name",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("测试商品042211")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("A00011")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("sf0425001")])]), _vm._v(" "), _c('div', {
    staticClass: "box_footer2",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('span', {
    staticClass: "box_time",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('span', {
    staticClass: "l_label",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("合箱时间：")]), _c('span', {
    staticClass: "l_value",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("2021-04-25 07:50:54")])]), _vm._v(" "), _c('span', {
    staticClass: "box_type",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('span', {
    staticClass: "l_label",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("运输方式：")]), _c('span', {
    staticClass: "l_value",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("海运")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dc2c98d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/face.vue
// module id = 1224
// module chunks = 2